import { useTransactions } from "@usher/pe-client-front-end-lib"
import { ExchangeFilter } from "@/components/Transactions/Exchange/ExchangeFilter"
import { ExchangeList } from "@/components/Transactions/Exchange/List"
import { TablePagination } from "@/components/Pagination/TablePagination"

const TYPE = "Sell"
const PER_PAGE = 5

export const TransactionsExchangeTypeSell = () => {
  const { data, isInitialized, isLoading, onFilter, dataTotal, pageCount, pageIndex, setPageIndex } = useTransactions({
    type: TYPE,
    pageSize: PER_PAGE,
  })

  return (
    <>
      <ExchangeFilter onFilter={onFilter} type={TYPE} />
      <ExchangeList type={TYPE} orders={data} isInitialized={isInitialized} loading={isLoading} />
      <TablePagination dataTotal={dataTotal} currentPage={pageIndex} totalPages={pageCount} onPageChange={setPageIndex} />
    </>
  )
}
